import { render, staticRenderFns } from "./ModuloNutricao.vue?vue&type=template&id=7f020a60&"
import script from "./ModuloNutricao.vue?vue&type=script&lang=js&"
export * from "./ModuloNutricao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports